import { get, join } from "lodash"
import { takeLatest, call, getContext } from "redux-saga/effects"
import { createReducer } from "reduxsauce"
import queryString from "query-string"
import actionCreator from "helpers/actionCreator"
import { createDefaultReducer } from "helpers/reducers"

export const { Types, Creators } = actionCreator("ompnt/modules/market-tools", {
  selectScreen: ["screen"],
  setModel: {
    props: ["model"],
    updatePreference: {
      getItems: (state, { model }) => [{
        type: "marketToolsLastModelUsed",
        value: model,
        key: get(state, "global.selected.account"),
      }],
    },
  },
})

const DEFAULT_STATE = {}

export default createReducer(DEFAULT_STATE, {})

export const queryStringReducers = {
  [Types.SET_MODEL]: createDefaultReducer(),
}

function* handleSelectScreen({ screen }) {
  const { pathname, search } = window.location
  const { model } = queryString.parse(search)
  const pathParts = pathname.split("/", 4)
  const newPath = get(screen, "id")
  let newUrl = `${join(pathParts, "/")}/${newPath}`
  if (model) {
    newUrl += `?model=${model}`
  }
  const { navigate } = yield getContext("router")
  yield call(navigate, newUrl)
}

export function* saga() {
  yield takeLatest(Types.SELECT_SCREEN, handleSelectScreen)
}
